<div class="usc-wrapper">

  <!-- SECCIÓN SUPERIOR: encabezado -->
  <div class="usc-header">
    <button class="usc-close" (click)="stay()">&#x2715;</button>
  </div>

  <!-- Icono de advertencia superpuesto entre las dos secciones -->
  <div class="usc-icon-wrapper">
    <div class="usc-icon">
      <img src="assets/img/modals/unsaved-changes/Cancelar_icono.png" alt="Advertencia" />
    </div>
  </div>

  <!-- SECCIÓN INFERIOR: contenido -->
  <div class="usc-body">
    <h2 class="usc-title">¿Seguro que quieres salir?</h2>
    <p class="usc-desc">Si sales ahora, perderás la información que has registrado hasta el momento. ¿Deseas salir?</p>

    <div class="usc-actions">
      <button class="usc-btn usc-btn--filled" (click)="stay()">Continuar</button>
      <button class="usc-btn usc-btn--outline" (click)="leave()">Sí, salir</button>
    </div>
  </div>

</div>
